import Banner from "./Banner";
import ContactSection from "./ContactSection";
import Consultation from "./Consultation";
import Whatsapp from "./WhatsApp";

const ContactUs = ({ language }) => {
  return (
    <>
      <Banner language={language} />
      <Consultation language={language} />
      <Whatsapp language={language} />
      <ContactSection language={language} />
    </>
  );
};

export default ContactUs;